import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { TiUserAdd } from "react-icons/ti";
import { WiTime3 } from "react-icons/wi";
import { set } from "date-fns";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import Swal from "sweetalert2";
const Networks = () => {
  const [isloading, setIsLoading] = useState(false);
  const [invitationcount, setInvitationCount] = useState("");
  const [users, setUsers] = useState([]);
  const [sendRequests, setSendRequests] = useState([]);
  const [recievedRequests, setRecievedRequests] = useState([]);
  const [value, setValue] = React.useState("1");
  const [generalinfo, setGeneralInfo] = useState({});
  const [recommendations, setRecommendations] = useState([]);
  const tabs = [
    { label: "Grow", value: "1" },
    { label: "Catch up", value: "2" },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [activeTab, setActiveTab] = useState("All");

  const tabOptions = [
    "All",
    "Job Changes",
    "Birthdays",
    "Work anniversaries",
    "Education",
  ];

  const getTabContent = () => {
    switch (activeTab) {
      case "Job Changes":
        return <div className="p-4">🎉 Showing Job Changes</div>;
      case "Birthdays":
        return <div className="p-4">🎂 Showing Birthdays</div>;
      case "Work anniversaries":
        return <div className="p-4">🏆 Showing Work Anniversaries</div>;
      case "Education":
        return <div className="p-4">🎓 Showing Education</div>;
      case "All":
      default:
        return <div className="p-4">📋 Showing All Highlights</div>;
    }
  };

  useEffect(() => {
    getGeneralInfo();
    getRecommendations();
    getSendRequests();
    getRecievedRequests();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const token = Cookies.get("token");
    try {
      const result = await axios.get(BaseUrl + "getusers", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setUsers(result.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getGeneralInfo = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(BaseUrl + `generalinfo`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      if (response.status === 200) {
        setGeneralInfo(response.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getRecommendations = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(BaseUrl + `recommendations`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });

      if (response.data.status === 200) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getSendRequests = async () => {
    const token = Cookies.get("token");
    try {
      const result = await axios.get(BaseUrl + "getsendrequests", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setSendRequests(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRecievedRequests = async () => {
    const token = Cookies.get("token");
    try {
      const result = await axios.get(BaseUrl + "getrecievedrequests", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setRecievedRequests(result.data.data);
        setInvitationCount(result.data.data.length);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleConnect = async (id, index) => {
    const updatedUsers = [...users];
    updatedUsers[index] = {
      ...updatedUsers[index],
      request_status: "pending",
    };
    setUsers(updatedUsers);
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("request_to", id);
    try {
      const result = await axios.post(BaseUrl + `addtonetwork`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Connection request sent!",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to send request",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      console.log(error);
    }
  };
  const handleAccept = async (id) => {
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await axios.post(BaseUrl + `acceptrequest`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setRecievedRequests((prevRequests) =>
          prevRequests.filter((request) => request.id !== id)
        );
        getData();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleDecline = async (id) => {
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await axios.post(BaseUrl + `rejectrequest`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setRecievedRequests((prevRequests) =>
          prevRequests.filter((request) => request.id !== id)
        );
        getData();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getColorFromName = (name) => {
    if (!name) return { backgroundColor: "hsl(0, 0%, 50%)" };

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;
    const saturation = 70 + (Math.abs(hash) % 30); // 70–99%
    const lightness = 50 + (Math.abs(hash) % 10);

    return {
      backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
    };
  };

  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-10 ">
          <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-1/4 ">
              <div className="bg-white rounded-lg border border-gray-300">
                <h2 className="text-lg text-black font-normal  border-b border-gray-300 px-4 py-2">
                  Manage my network
                </h2>
                <div className=" text-lg text-gray-600 overflow-hidden0">
                  <Link
                    to="/user/networks/connections"
                    className="flex items-center justify-between hover:bg-gray-200 "
                  >
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-user-friends mr-2"></i>
                      <p>Connections</p>
                    </div>
                    <div className="px-4 py-2">
                      <p>{generalinfo.connection_count}</p>
                    </div>
                  </Link>
                  <Link to="/user/networks/following-followers">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-user-plus mr-2"></i>
                      <p>Following & Followers</p>
                    </div>
                  </Link>
                  <Link
                    to="/groups"
                    className="flex items-center justify-between hover:bg-gray-200 "
                  >
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-users mr-2"></i>
                      <p>Groups</p>
                    </div>
                    <div className="px-4 py-2">
                      <p>{generalinfo.group_count}</p>
                    </div>
                  </Link>
                  <Link
                    to="/events"
                    className="flex items-center justify-between hover:bg-gray-200 "
                  >
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-calendar-alt mr-4"></i>
                      <p>Events</p>
                    </div>
                    <div className="px-4 py-2">
                      <p>{generalinfo.event_count}</p>
                    </div>
                  </Link>
                  {/* <Link to="/pages">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-newspaper mr-3"></i>
                      <p>Pages</p>
                    </div>
                  </Link>
                  <Link to="/newsletters">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-newspaper mr-3"></i>
                      <p>Newsletters</p>
                    </div>
                  </Link> */}
                </div>
              </div>
            </div>

            <div className="w-full lg:w-3/4 ">
              <div className=" ">
                <div className=" flex">
                  <Box
                    className="muibox"
                    sx={{ width: "100%", typography: "body1" }}
                  >
                    <TabContext value={value}>
                      <Box
                        className="muibox"
                        sx={{
                          border: "1px solid #ccc",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          borderColor: "#D1D5DB",
                        }}
                      >
                        <TabList
                          onChange={handleChange}
                          aria-label="Dynamic Tabs Example"
                          textColor="primary"
                          indicatorColor="primary"
                        >
                          {tabs.map((tab) => (
                            <Tab
                              key={tab.value}
                              label={tab.label}
                              value={tab.value}
                              sx={{
                                color:
                                  value === tab.value ? "#1976D2" : "#757575",
                                fontWeight:
                                  value === tab.value ? "bold" : "normal",
                                fontSize: "16px",
                                mx: 2,
                                textTransform: "capitalize",
                                // borderBottom: value === tab.value ? "3px solid green" : "none",
                                // "&.Mui-selected": {
                                //   color: "green",
                                // },
                                "&:hover": {
                                  backgroundColor: "#F3F4F6",
                                },
                              }}
                            />
                          ))}
                        </TabList>
                      </Box>

                      <TabPanel value="1">
                        <div className="bg-white border border-gray-300 rounded-lg shadow mb-4">
                          {invitationcount > 0 ? (
                            <div className=" flex items-center justify-between  py-2">
                              <h2 className="text-lg text-gray-500 px-4">
                                Invitations ({invitationcount})
                              </h2>
                              <Link to={"/user/networks/manageinvitation"}>
                                <h2 className="text-lg  text-gray-500 px-4">
                                  Show all
                                </h2>
                              </Link>
                            </div>
                          ) : (
                            <div className=" flex items-center justify-between  py-2">
                              <h2 className="text-lg text-gray-500 px-4">
                                No pending invitations
                              </h2>
                              <Link to={"/user/networks/manageinvitation"}>
                                <h2 className="text-lg  text-gray-500 px-4">
                                  Manage
                                </h2>
                              </Link>
                            </div>
                          )}

                          {recievedRequests ? (
                            <div className=" ">
                              {recievedRequests.map((request, index) => (
                                <div
                                  key={index}
                                  className="flex  justify-between px-4 border-b border-gray-200 p-2"
                                >
                                  <div className="flex items-center gap-4">
                                    <Link to={`/user/profile/${request.slug}`}>
                                      {request.profile ? (
                                        <img
                                          src={request.profile}
                                          alt={request.name}
                                          className="w-12 h-12 rounded-full object-cover"
                                        />
                                      ) : (
                                        <div
                                          className="w-12 h-12 rounded-full  text-white flex items-center justify-center font-semibold text-lg"
                                          style={getColorFromName(
                                            request.name || "?"
                                          )}
                                        >
                                          {request.name.charAt(0)}
                                        </div>
                                      )}
                                    </Link>
                                    <Link
                                      to={`/user/profile/${request.slug}`}
                                      className=""
                                    >
                                      <p className="text-gray-800 text-lg font-semibold">
                                        {request.name}
                                      </p>
                                      <p className="text-gray-500">
                                        {request.headline}
                                      </p>
                                      {request.company && (
                                        <p className="text-gray-500 text-sm">
                                          <i className="fas fa-building text-sm text-gray-500 "></i>{" "}
                                          {request.company}
                                        </p>
                                      )}
                                    </Link>
                                  </div>
                                  <div className="flex items-center justify-between gap-2">
                                    <button
                                      className="flex items-center justify-between gap-1 px-4 py-1 text-gray-600 rounded-full hover:text-gray-700  hover:bg-gray-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                      onClick={() =>
                                        handleDecline(request.network_id)
                                      }
                                    >
                                      Ignore
                                    </button>
                                    <button
                                      className="flex items-center justify-between gap-1 px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                      onClick={() =>
                                        handleAccept(request.network_id)
                                      }
                                    >
                                      Accept
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : null}
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow mb-4">
                          <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold">
                              Recommended for you
                            </h2>
                            <Link to="#" className="text-blue-500">
                              See all
                            </Link>
                          </div>

                          {users?.filter(
                            (user) =>
                              user.request_status === null ||
                              user.request_status === 0 ||
                              user.request_status === "pending"
                          ).length === 0 ? (
                            <div className="text-center py-8">
                              <p className="text-gray-500">
                                No recommendations available at the moment.
                              </p>
                              <p className="text-gray-400 text-sm mt-2">
                                We'll show you recommendations based on your
                                profile and network when they become available.
                              </p>
                            </div>
                          ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                              {users?.map(
                                (user, index) =>
                                  (user.request_status === null ||
                                    user.request_status === 0 ||
                                    user.request_status === "pending") && (
                                    <div
                                      key={index}
                                      className="relative bg-white rounded-lg shadow-xl  w-full"
                                    >
                                      <Link to={`/user/profile/${user.slug}`}>
                                        <div className="flex flex-col items-center mt-4">
                                          <div className="relative h-20 w-full rounded-t-lg bg-gray-100">
                                            {user.bg_profile ? (
                                              <img
                                                src={user.bg_profile}
                                                alt="Profile background"
                                                className="absolute inset-0 w-full h-full rounded-t-lg object-cover"
                                              />
                                            ) : (
                                              <img
                                                src="/Images/cover-img.jpg"
                                                alt="Default background"
                                                className="absolute inset-0 w-full h-full rounded-t-lg object-cover"
                                              />
                                            )}
                                            {user.profile ? (
                                              <img
                                                src={user.profile}
                                                alt={user.name}
                                                className="absolute bottom-4 left-12 w-24 h-24 rounded-full border-2 border-white object-cover"
                                                style={{
                                                  transform: "translateY(50%)",
                                                }}
                                              />
                                            ) : (
                                              <div
                                                className="absolute bottom-4 left-12 w-24 h-24 rounded-full border-2 border-white flex items-center justify-center text-white font-semibold text-2xl"
                                                style={{
                                                  ...getColorFromName(
                                                    user.name || "?"
                                                  ),
                                                  transform: "translateY(50%)",
                                                }}
                                              >
                                                {user.name.charAt(0)}
                                              </div>
                                            )}
                                          </div>

                                          <h2 className="mt-4 text-lg font-semibold text-center pt-6 px-2 leading-[1.35]">
                                            {user.name}
                                          </h2>
                                          <p className="text-gray-500 text-center text-sm leading-[1.25] px-2">
                                            {user.headline}
                                          </p>
                                        </div>
                                      </Link>

                                      <div className="flex justify-center mt-4 space-x-4 pb-6">
                                        {user.request_status === null ||
                                        user.request_status === 0 ? (
                                          <button
                                            className="flex items-center justify-between gap-1 px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                            onClick={() =>
                                              handleConnect(user.id, index)
                                            }
                                          >
                                            <span className="text-xl">
                                              <TiUserAdd />
                                            </span>
                                            Connect
                                          </button>
                                        ) : (
                                          <button
                                            className="flex items-center justify-between gap-1  px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85 cursor-not-allowed"
                                            disabled
                                          >
                                            <span className="text-xl">
                                              <WiTime3 />
                                            </span>
                                            Pending
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  )
                              )}
                            </div>
                          )}
                        </div>
                      </TabPanel>

                      <TabPanel value="2">
                        <div className="bg-white border border-gray-300 rounded-lg">
                          <div className="flex items-center justify-around border-b border-gray-300 py-4">
                            {tabOptions.map((tab) => (
                              <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={`border border-gray-300 text-md rounded-2xl px-4 py-1 ${
                                  activeTab === tab
                                    ? "bg-blue-600 text-white"
                                    : "text-gray-700"
                                }`}
                              >
                                {tab}
                              </button>
                            ))}
                          </div>
                          {/* Conditional content based on selected tab */}
                          {getTabContent()}
                        </div>
                      </TabPanel>
                    </TabContext>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Networks;
